export default function ButtonsPointRange() {
  return (
    <div className="side2" id="subCats">
      <span className="point-range-result">0~10/10</span>
      <div className="point-range">
        <div className="point-range-bar"></div>
        <div className="point-range-right"></div>
        <div className="point-range-left"></div>
      </div>
      <div className="button enabled" id="show-recos-without-points">Show recos without points</div>
      <div className="button" id="show-only-unrecoed">Show only unrecoed on mine</div>
      <div className="cBoth"></div>
    </div>
  );
}
